import { LinkProps } from "@chakra-ui/react";
import colors from "app/colors";

const selectedTagGroupNavLinkProps: LinkProps = {
  bg: `${colors.orangePrimary}66`,
  color: "white",
  fontWeight: 600,
  rounded: "sm",
};

export default selectedTagGroupNavLinkProps;
